import { useAuth } from "@/Auth/useAuth";

export type WebAppPrivileges = {
  spotter: boolean;
  drill_down: boolean;
  search_data: boolean;
};

export function useUserPrivileges(): WebAppPrivileges {
  const auth = useAuth();

  const defaultPrivileges: WebAppPrivileges = {
    spotter: false,
    drill_down: false,
    search_data: false,
  };

  if (auth.isAuthenticated && auth.user?.meta?.norma?.web_app_privileges) {
    return auth.user.meta.norma.web_app_privileges;
  }

  return defaultPrivileges;
}
